import { IndicatorType } from '../constants/common'
import { AroonCalculation } from '../indicator-calculation/aroon'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class AroonOscillator extends Indicator<Attrs> {
  static type = IndicatorType.Aroosc
  static label = 'Aroon Oscillator'

  aroonCalculation: AroonCalculation | null = null
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (!this.isComputeNecessary() && this.aroonCalculation !== null) return

    this.aroonCalculation = new AroonCalculation({
      quote: this.data,
      options: { period: this.period },
    })

    this.aroonCalculation.calculate()

    this.lastValue = this.aroonCalculation.calculatedValues.oscillator.last() ?? null
    const { min, max } = this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    this.renderOversoldOverbought(
      context,
      this.aroonCalculation?.calculatedValues.oscillator ?? [],
      this.period,
      0,
      0,
      0,
      false
    )
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 25,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `Aroon Oscillator ${this.period}`
  }
}

export default AroonOscillator
